import { render, staticRenderFns } from "./WebshopModal.vue?vue&type=template&id=3e83fa60"
import script from "./WebshopModal.vue?vue&type=script&lang=js"
export * from "./WebshopModal.vue?vue&type=script&lang=js"
import style0 from "./WebshopModal.vue?vue&type=style&index=0&id=3e83fa60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports